<!-- Placeholder Loader -->
<app-placeholder-loader *ngIf="!fundraiser"></app-placeholder-loader>

<!-- sip-top banner -->
<div *ngIf="vwo.otd_to_sip_AB()">
  <app-otd-to-sip [config]="{v: 'v2', fundraiser: fundraiser}"></app-otd-to-sip>
</div>
<div class="sip-top-banner-wrapper">
  <app-sip-top-banner></app-sip-top-banner>
</div>

<!-- Fundraiser Ended label -->
<app-end-fundraiser-banner *ngIf="fundraiser" [isFundraiserEnded]="isFundraiserEnded" [isSuccessfullyFunded]="isSuccessfullyFunded"
                          [fundraiser]="fundraiser" [campaignUrl]="campaignUrl" [basicInfo]="basicInfo"
                          [sharedCounts]="sharedCounts">
</app-end-fundraiser-banner>
<!-- Ended Fundraiser/Story Sip Banner -->
<app-fundraiser-sipbanner *ngIf="isFundraiserEnded" (click)="openSimilarFundraiserDialog=false"
                        [config]="{
                          hideEndText: false,
                          hideDock: false,
                          info_3: 'ended',
                          queryParams: { utm_term: 'endedfundraiser', utm_content: 'banner' }
                        }">
</app-fundraiser-sipbanner>
<!-- Thank you banner -->
<app-thankyou-banner *ngIf="fundraiser" [fundraiser]="fundraiser" [isDonated]="isDonated" [donations]="donationCard?.donor"></app-thankyou-banner>
<!--Pre Approve banner for medical-->
<app-pre-approve-banner *ngIf="fundraiser && fundraiser.status_flag === 8" [fundraiser]="fundraiser"></app-pre-approve-banner>

<div #fundraiserTemp>
  <div *ngIf="fundraiser" class="fr-container">
  	<!-- Edit fundraiser button for campaigners -->
    <div class="container edit-fundraiser" *ngIf="showEditFrBtn">
      <button type="button" (click)="goToManageFund()" mat-stroked-button class="edit-fundraiser-btn" color="primary">
        <span class="material-icons">
          edit
        </span>
        Edit fundraiser
      </button>
    </div>
    <!-- Tag for event campaigns -->
    <div class="container mt-4" *ngIf="fundraiser?.organiser">
      <div class="event-campaign">
        <span class="event-campaign-span">
          <i class="icon-topdonor"></i>
          <span>
            This fundraiser is a part of the event
            <a href="https://{{fundraiser.organiser.access_url}}" class="link">{{ fundraiser.organiser.full_name }}</a>.
         </span>
        </span>
      </div>
    </div>
    <!-- Urgent Text for medical campaign -->
    <div class="flex-container-row urgent-text" *ngIf="checkIfUrgentFundraiser() && !isFundraiserEnded">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 297 297" xml:space="preserve"><g><path d="M259.352,219.903H37.647c-5.485,0-9.933,4.447-9.933,9.933v41.586c0,5.486,4.447,9.934,9.933,9.934h221.705 c5.485,0,9.933-4.447,9.933-9.934v-41.586C269.285,224.351,264.838,219.903,259.352,219.903z" fill="#c1272d"></path><path d="M47.58,164.191c0-5.485-4.447-9.934-9.934-9.934H9.934c-5.486,0-9.934,4.448-9.934,9.934c0,5.485,4.447,9.933,9.934,9.933 h27.713C43.133,174.124,47.58,169.677,47.58,164.191z" fill="#c1272d"></path><path d="M58.335,88.046c1.938,1.94,4.481,2.91,7.023,2.91s5.084-0.97,7.023-2.909c3.88-3.878,3.88-10.168,0.001-14.047 L58.525,60.141c-3.876-3.879-10.166-3.879-14.047-0.001c-3.88,3.879-3.88,10.168-0.001,14.047L58.335,88.046z" fill="#c1272d"></path><path d="M231.641,90.956c2.542,0,5.085-0.97,7.023-2.91l13.857-13.859c3.879-3.879,3.879-10.168-0.001-14.047 c-3.879-3.88-10.169-3.879-14.047,0.001L224.616,74c-3.879,3.879-3.879,10.169,0.001,14.047 C226.557,89.986,229.098,90.956,231.641,90.956z" fill="#c1272d"></path><path d="M287.066,154.258h-27.714c-5.486,0-9.934,4.448-9.934,9.934c0,5.485,4.447,9.933,9.934,9.933h27.714 c5.486,0,9.934-4.447,9.934-9.933C297,158.706,292.553,154.258,287.066,154.258z" fill="#c1272d"></path><path d="M148.499,63.234c5.485,0,9.934-4.447,9.934-9.934V25.578c0-5.486-4.448-9.934-9.934-9.934 c-5.485,0-9.933,4.447-9.933,9.934v27.723C138.566,58.787,143.014,63.234,148.499,63.234z" fill="#c1272d"></path><path d="M241.573,164.191c0-51.336-41.753-93.102-93.073-93.102s-93.073,41.766-93.073,93.102v33.169c0,4.95,4.05,9,9,9h168.146 c4.95,0,9-4.05,9-9V164.191z" fill="#c1272d"></path></g></svg>
      <span>This fundraiser is in an urgent need of funds</span>
    </div>
    <div [ngClass]="{'container': !isMobile}">
      <div class="row" [ngClass]="{'no-gutters': isMobile}">
        <div class="col-12 fr-title">{{fundraiser?.title}}</div>
        <div class="col-md-8 col-lg-8 col-sm-12 col-xs-12">
          <!-- Image Slider -->
          <div class="fr-image-slider desktop-shadow-card">
            <div class="tax-benefit">
              <div *ngIf="fundraiser?.beneficiary?.tax_benefit" class="taxt-container">
                <img loading="lazy" data-src="/assets/images/tax.svg" alt="Tax Benefit Ribbon" src="/assets/images/transparent.png">
              </div>
              <span class="tooltipText">80G Tax Exemption Certificate Available</span>
            </div>

            <app-fundraiser-slider-img [gallery]="fundraiser?.gallery" [basicInfo]="basicInfo" [isFOS]="isFos" [hasThumbs]="isMobile ? false : true" [slideType]="'leaderboard'" [shadow]="isMobile ? true : false"></app-fundraiser-slider-img>

          </div>
            <!-- Fundraiser Short Description for mobile-->
          <div class="col-12 fr-short-description" *ngIf="isMobile">{{basicInfo?.about}}</div>

          <!-- memorial-nudge for mobile -->
          <div *ngIf="isMobile && isSipCause" class="memorial-nudge mb-3" (click)="openPaymentForm('c')">
            <app-memorial-nudge [cause]="fundraiser?.sipcause"></app-memorial-nudge>
          </div>

          <!-- Social share button for mobile -->
          <div class="col-12 sticky-top sticky-top-wrapper" *ngIf="isMobile">
            <!-- Socail Share -->
            <app-social-share [fundraiser]="fundraiser" [sharedCounts]="sharedCounts" [metaData]="metaData"
                              [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo">
            </app-social-share>
          </div>
          <div class="fr-short-desc" *ngIf="!isFundraiserEnded && isMobile">
            Every Social media share can bring
            <strong>
              <span>
                <app-currency-icon [currency]='currency'></app-currency-icon> {{ socialImpactCurrencyList[currency] }}
              </span>
            </strong>
          </div>
          <div *ngIf="isMobile">
            <!-- Ammount Card -->
            <app-amount-card *ngIf="(!isFundraiserEnded || variablesService?.fundraiser?.isDonated)" [goal]="fundraiser?.amount_requested" [raised]="fundraiser?.raised?.raised"
              [supporters]="fundraiser?.raised?.backers" [date]="fundraiser?.end_date" [currency]="currency"
              [isFundraiserEnded]="isFundraiserEnded" [fundraiser]="fundraiser">
            </app-amount-card>
            <app-coupon-info *ngIf="fundraiser?.valid_coupon?.redeem_transfer_apply && !variablesService.isFundraiserEnded" [couponDetails]="fundraiser?.valid_coupon?.redeem_transfer_apply"></app-coupon-info>
            <!-- View all supporters on for mobile -->
            <app-view-supporters *ngIf="fundraiser?.raised?.beforeTickrBackers>10 && !fundraiser?.settings?.nodonorlist && (!isFundraiserEnded || variablesService?.fundraiser?.isDonated)" [fundraiser]="fundraiser"
                [customTag]="param" [settings]="fundraiser?.settings" [isFundraiserEnded]="isFundraiserEnded"
                [donationCard]="donationCard.donor.length" [isDonated]="isDonated" [tickrIsShown]="tickrIsShown">
            </app-view-supporters>
            <!-- Campaigner and Beneficiary card -->
            <app-campaigner-info [campaigner]="campaigner" [beneficiary]="beneficiary" [fundraiser]="fundraiser"></app-campaigner-info>
            <!-- Donor Card -->
            <app-support-card [donations]="donationCard.donor"
                *ngIf="isLoggedIn && donationCard.donor && donationCard.donor.length" cardType="donor">
            </app-support-card>
            <!--Sharee card -->
            <app-support-card [donations]="donationCard.shary"
                *ngIf="isLoggedIn && donationCard.shary && donationCard.shary.length" cardType="sharee">
            </app-support-card>
          </div>

          <div class="fr-tabs">

            <app-fr-tabs #tabs inViewport (inViewportAction)="tabsInView($event)"
                      [about]="basicInfo.social"
                      [isFundraiserEnded]="isFundraiserEnded"
                      [team]="fundraiser?.activeteam"
                      [supporters]="supportersObject"
                      [comments]="comments"
                      [customTag]="param"
                      [documents]="fundraiser?.viewmedicalbill"
                      [updates]="updates"
                      [fundraiser]="fundraiser"
                      [basicInfo]="basicInfo"
                      [isLoading]="isLoading"
                      [donateBtnLabel]="donateBtnLabel"
                      [sharedCounts]= "sharedCounts"
                      [isDonated]="isDonated"
                      [donationCard]="donationCard?.donor"
                      (headerSticky)="headerSticky($event)"
                      (activeTab)="getAciveTab($event)">
            </app-fr-tabs>
          </div>

        </div>

        <div class="col-md-4 col-lg-4 col-sm-12 col-xs-12" [ngClass]="{'right-section': !isMobile}">
          <!-- memorial-nudge for desktop -->
          <div *ngIf="!isMobile && isSipCause" class="memorial-nudge mb-3" (click)="openPaymentForm('c')">
            <app-memorial-nudge [cause]="fundraiser?.sipcause"></app-memorial-nudge>
          </div>
          <!-- Contribute now -->
          <div *ngIf="!isMobile" class="fr-contribute desktop-cards">
            <app-donate-now #donateNowBtn *ngIf="!isFundraiserEnded" [label]="donateBtnLabel" [fundraiser]="fundraiser"[position]="1" [icon]="true" [openDonate]="true" [sipCause]="fundraiser?.sipcause?.info_3"></app-donate-now>
            <button *ngIf="isFundraiserEnded" mat-raised-button type="button" (click)="startSimilar()"class="sf-btn ended-btn">Start a similar fundraiser</button>
          </div>
          <!--Banking other options-->
          <div *ngIf="!isFundraiserEnded && currency==='INR' && !isMobile" [hidden]="!fundraiser?.settings?.donation_button" class="payment-modes-options">
            <ul class="list-inline">
              <li (click)="openPaymentForm('c')" class="credit-debit"></li>
              <li (click)="openPaymentForm('nb')" class="netbank"></li>
              <li (click)="scrollIntoView('upi')" class="paytm-wallets"></li>
              <li *ngIf="fundraiser?.banktransfer?.info_3" (click)="scrollIntoView('bank')" class="bank-transfer"></li>
            </ul>
          </div>

          <div class="desktop-cards">
            <!--fb share-->
            <app-fb-share *ngIf="!isFundraiserEnded && !isMobile" class="fb-btn" label="Spread the word" [position]="1"
              [campaign_url]="campaignUrl" [count]="sharedCounts.fb">
            </app-fb-share>
            <div class="fr-short-desc" *ngIf="!isFundraiserEnded && !isMobile">
              Every Social media share can bring
              <strong >
                <span>
                  <app-currency-icon [currency]='currency'></app-currency-icon>{{ socialImpactCurrencyList[currency] }}
                </span>
              </strong>
            </div>
          </div>

          <div *ngIf="!isMobile">
            <!-- Ammount Card -->
            <app-amount-card *ngIf="(!isFundraiserEnded || variablesService?.fundraiser?.isDonated)" [goal]="fundraiser?.amount_requested" [raised]="fundraiser?.raised?.raised"
              [supporters]="fundraiser?.raised?.backers" [date]="fundraiser?.end_date" [currency]="currency"
              [isFundraiserEnded]="isFundraiserEnded" [fundraiser]="fundraiser">
            </app-amount-card>
            <app-coupon-info *ngIf="fundraiser?.valid_coupon?.redeem_transfer_apply && !variablesService.isFundraiserEnded" [couponDetails]="fundraiser?.valid_coupon?.redeem_transfer_apply"></app-coupon-info>

            <!-- Campaigner and Beneficiary card -->
            <app-campaigner-info [campaigner]="campaigner" [beneficiary]="beneficiary" [fundraiser]="fundraiser"></app-campaigner-info>
            <!-- Matching Dontions -->
            <app-matching-donation-card *ngIf="fundraiser?.matching_donor" [campaigner]="fundraiser?.matching_donor"></app-matching-donation-card>
            <!-- Donor Card -->
            <app-support-card [donations]="donationCard.donor"
                *ngIf="isLoggedIn && donationCard.donor && donationCard.donor.length" cardType="donor">
            </app-support-card>
            <!--Sharee card -->
            <app-support-card [donations]="donationCard.shary"
                *ngIf="isLoggedIn && donationCard.shary && donationCard.shary.length" cardType="sharee">
            </app-support-card>
          </div>
          <!-- Supporting Fundraiser card -->
          <app-supporting-fr-card *ngIf="currency && !isMobile && fundraiser?.status_flag !== 8 && (!isFundraiserEnded || variablesService?.fundraiser?.isDonated)" [fundraiser]="fundraiser" [currency]="currency" [isFundraiserEnded]="isFundraiserEnded"></app-supporting-fr-card>
          <!-- Top donors in varies category list -->
          <app-supporter *ngIf="!fundraiser?.settings?.nodonorlist && !isMobile && (!isFundraiserEnded || variablesService?.fundraiser?.isDonated)" [isFundraiserEnded]="isFundraiserEnded"
            [isLoading]="isLoading" [donateBtnLabel]="donateBtnLabel" [supporters]="supportersObject"
            [settings]="fundraiser.settings" [fundraiser]="fundraiser">
          </app-supporter>
          <!-- Matching Dontions -->
          <app-matching-donation-card *ngIf="fundraiser?.matching_donor && isMobile" [campaigner]="fundraiser?.matching_donor"></app-matching-donation-card>
          <!-- Rewards -->
          <app-reward [rewards]="fundraiser?.rewards" [fundraiser]="fundraiser" [isFundraiserEnded]="isFundraiserEnded"></app-reward>
          <!-- No donation placholder -->
          <app-fr-card *ngIf="!fundraiser?.raised && !isFundraiserEnded" class="first-to-donate">
            <div class="first-occur">
            <p>This fundraiser has not received any donations yet!</p>
            <app-donate-now label="Be the first to donate" [icon]="true"></app-donate-now>
            </div>
          </app-fr-card>
        </div>
      </div>
    </div>
    <!-- Contribute now -->
    <div *ngIf="!isFundraiserEnded && isMobile" class="fr-contribute support-card">
      <mat-card class="fr-contribute-card">
        <span class="text-label"><span class="text-label-in">{{campaigner?.full_name}}</span> needs your support.</span>
        <div *ngIf="currency==='INR' && variablesService.showHFgift" inViewport (inViewportAction)="fixedPostion($event)">
          <div class="hf-gift-info">
            <app-component-loader [load]="true" selector="app-hf-gift-info-nudge" [inputs]="{showHeadOnly: true}"></app-component-loader>
          </div>
        </div>
        <div class="donation-btn" inViewport (inViewportAction)="fixedPostion($event)" [inViewportOptions]="{ threshold: [200] }">
          <!-- <div class="zero-fees">Ketto charges 0% platform fee for this fundraiser</div> -->
          <div class="donatebtn">
            <app-donate-now *ngIf="!vwo.quickDonate_fr_AB() || !userData || (userData?.lastorder?.iso_currency !== currency)" #donateNowBtn [label]="donateBtnLabel" [fundraiser]="fundraiser" [position]="9" [openDonate]="true" [sipCause]="fundraiser?.sipcause?.info_3"></app-donate-now>
          </div>
          <div *ngIf="vwo.quickDonate_fr_AB() && userData?.lastorder?.iso_currency === currency" class="fixed-button" [ngClass]="vwo.quickDonate_fr_AB() === 'v1' ? 'v1':''">
            <app-payment-otd [InputConfig]="{ frtip: fundraiser?.tip_model ? true : false, label: 'Stories.donations.makeDonation' | translatePipe | async,  theme:'v1',  fundraiser: fundraiser, position: 9, docked: true, slabTheme: 'slab-theme-v5', paymentBtnClass: 'payment-btn-theme-v4', origin: 'f', showSlabs: false, donatingAs: true, optionsCheck: false, onpage: true, donateBtnLabel:'Repeat donation of', onAmtForm: false, showBeneficiary: false, tip_only: false, showTip: fundraiser?.tip_model ? true : false }"></app-payment-otd>
          </div>
        </div>
        <app-donate-now *ngIf="vwo.quickDonate_fr_AB() && userData" #donateNowBtn [label]="donateBtnLabel" [fundraiser]="fundraiser" [position]="9" [openDonate]="true" [sipCause]="fundraiser?.sipcause?.info_3"></app-donate-now>
      </mat-card>
    </div>
    <!-- Report the fundraiser -->
    <div class="fr-contribute">
      <div class="report-project" inViewport (inViewportAction)="similarFundsInView($event)">
        <app-chat-with-us [html]="'Have a question? Check out our <a href=https://customerhappiness.ketto.org/portal/en/kb target=_blank>FAQs</a> page or chat with us on Facebook or WhatsApp.'" fbposition='5' whatsposition='5' pageName='campaign'></app-chat-with-us>
        <div class="text-left">
          <button *ngIf="!isMicroSite" color="primary" class="report-btn" (click)="reportProject()" mat-stroked-button>
            Report this fundraiser to Ketto
          </button>
        </div>
      </div>
    </div>
    <div class="container" *ngIf="fundraiser?.parent_cause_id != 149">
      <div class="disclaimer">
        Content Disclaimer: The views and opinions expressed on the campaign page are those of a campaigner or donors. They do not reflect or represent the company's views and opinions.
      </div>
    </div>
    <!-- Start similar fundraiser -->
    <div *ngIf="isFundraiserEnded && isMobile" class="fr-start-fundraiser">
      <div class="fixed-position">
        <button mat-raised-button type="submit" (click)="startSimilar()" class="sf-btn">Start a similar fundraiser</button>
      </div>
    </div>
    <!-- Similar fundraiser -->
    <div [ngClass]="{'outer-wrapper': !isMobile}" class="similar-fr-wrapper">
      <app-similar-fundraiser class="similar-fr" [fundraisers]="similarFundraisers" [slidesPerView]="4"
                              title="People like you donated to these Fundraisers">
      </app-similar-fundraiser>
    </div>
    <!-- Social share Overlay button -->
    <app-social-share-btn *ngIf="isMobile && variablesService.showSocialShare" [fundraiser]="fundraiser" [basicInfo]="basicInfo" [isFundraiserEnded]="isFundraiserEnded"></app-social-share-btn>
  </div>
  <!-- Urgent slide up sticky footer -->
  <div *ngIf="checkIfUrgentFundraiser() && !isFundraiserEnded" [hidden]="!isHeaderSticky">
    <div [@slideUp] *ngIf="isHeaderSticky" class="flex-container-row urgent-need">
      <div class="flex-container-row">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 297 297" xml:space="preserve"><g><path d="M259.352,219.903H37.647c-5.485,0-9.933,4.447-9.933,9.933v41.586c0,5.486,4.447,9.934,9.933,9.934h221.705 c5.485,0,9.933-4.447,9.933-9.934v-41.586C269.285,224.351,264.838,219.903,259.352,219.903z" fill="#01bfbd"></path><path d="M47.58,164.191c0-5.485-4.447-9.934-9.934-9.934H9.934c-5.486,0-9.934,4.448-9.934,9.934c0,5.485,4.447,9.933,9.934,9.933 h27.713C43.133,174.124,47.58,169.677,47.58,164.191z" fill="#01bfbd"></path><path d="M58.335,88.046c1.938,1.94,4.481,2.91,7.023,2.91s5.084-0.97,7.023-2.909c3.88-3.878,3.88-10.168,0.001-14.047 L58.525,60.141c-3.876-3.879-10.166-3.879-14.047-0.001c-3.88,3.879-3.88,10.168-0.001,14.047L58.335,88.046z" fill="#01bfbd"></path><path d="M231.641,90.956c2.542,0,5.085-0.97,7.023-2.91l13.857-13.859c3.879-3.879,3.879-10.168-0.001-14.047 c-3.879-3.88-10.169-3.879-14.047,0.001L224.616,74c-3.879,3.879-3.879,10.169,0.001,14.047 C226.557,89.986,229.098,90.956,231.641,90.956z" fill="#01bfbd"></path><path d="M287.066,154.258h-27.714c-5.486,0-9.934,4.448-9.934,9.934c0,5.485,4.447,9.933,9.934,9.933h27.714 c5.486,0,9.934-4.447,9.934-9.933C297,158.706,292.553,154.258,287.066,154.258z" fill="#01bfbd"></path><path d="M148.499,63.234c5.485,0,9.934-4.447,9.934-9.934V25.578c0-5.486-4.448-9.934-9.934-9.934 c-5.485,0-9.933,4.447-9.933,9.934v27.723C138.566,58.787,143.014,63.234,148.499,63.234z" fill="#01bfbd"></path><path d="M241.573,164.191c0-51.336-41.753-93.102-93.073-93.102s-93.073,41.766-93.073,93.102v33.169c0,4.95,4.05,9,9,9h168.146 c4.95,0,9-4.05,9-9V164.191z" fill="#01bfbd"></path></g></svg>
        <div class="urgent-title">This fundraiser is in an urgent need of funds
        </div>
        <app-donate-now [label]="donateBtnLabel" [fundraiser]="fundraiser" [position]="6"></app-donate-now>
      </div>
    </div>
  </div>
  <!-- Urgent slide up sticky footer -->
  <div *ngIf="!checkIfUrgentFundraiser() && !isFundraiserEnded">
    <div [@slideUp] *ngIf="isHeaderSticky" class="flex-container-row urgent-need">
      <div class="flex-container-row">
        <div class="urgent-title">{{fundraiser?.campaigner?.full_name+' needs your support'}}
        </div>
        <app-donate-now label="Support Now" [fundraiser]="fundraiser" [position]="6"></app-donate-now>
      </div>
    </div>
  </div>
</div>
<!-- payment module -->
<app-main-payment class="d-none" *ngIf="fundraiser && !isFundraiserEnded && actRoute.snapshot.queryParams['st'] === 'f'" [internal]="true" [fundraiser]="fundraiser" origin="f" type="onpage"></app-main-payment>

<!-- Similar fundraiser Popup -->
<ng-template #similarFundraiser>
  <div class="dialog">
    <div class="dialog-header">
      <button (click)="dialog.closeAll()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="dialog-title">
      <span>This fundraiser has ended!</span>
    </div>
    <div class="dialog-subtitle">Here is a similar fundraiser that needs your help right now.</div>
    <div class="dialog-content" matDialogContent>
      <app-similar-fundraiser [fundraisers]="similarFundraisers" title="Trending Fundraiser" [slidesPerView]="3.2" [config]="{sysEventOnClick: true}"></app-similar-fundraiser>
    </div>
  </div>
</ng-template>
<!-- Below Element added to show tickr in fundraiser desktop (CSS visibility hidden for supoorters in desktop) -->
<app-view-supporters
  *ngIf="fundraiser?.raised?.beforeTickrBackers>10 && !fundraiser?.settings?.nodonorlist && !isMobile"
  [fundraiser]="fundraiser"
  [customTag]="param"
  [settings]="fundraiser?.settings"
  [isFundraiserEnded]="isFundraiserEnded"
  [donationCard]="donationCard.donor.length"
  [isDonated]="isDonated"
  [tickrIsShown]="tickrIsShown">
</app-view-supporters>

<!-- ended fundraiser sip popup -->
<app-ended-fundraiser-sip-dialog *ngIf="isFundraiserEnded && fundraiser?.parent_cause_id!==48"
                                  [fundraiser]="fundraiser" [currency]="currency">
</app-ended-fundraiser-sip-dialog>